import { Callable } from "@renproject/utils";
import axios from "axios";
import { fixUTXO, fixUTXOs, fixValue, sortUTXOs, DEFAULT_TIMEOUT, } from "./API";
export class BitcoinDotComClass {
    constructor({ testnet = false } = {}) {
        this.endpoint = () => this.testnet
            ? "https://trest.bitcoin.com/v2/"
            : "https://rest.bitcoin.com/v2/";
        this.endpointV2 = () => this.testnet
            ? "https://explorer-tbch.api.bitcoin.com/tbch/v1"
            : "https://explorer.api.bitcoin.com/bch/v1";
        this.fetchUTXO = async (txHash, vOut) => {
            const url = `${this.endpointV2()}/tx/${txHash}`;
            const response = await axios.get(`${url}`, {
                timeout: DEFAULT_TIMEOUT,
            });
            const utxo = response.data;
            return fixUTXO({
                txHash,
                amount: utxo.vout[vOut].value.toString(),
                vOut,
                confirmations: utxo.confirmations,
            }, 8);
        };
        this.fetchUTXOs = async (address, confirmations = 0) => {
            const url = `${this.endpointV2()}/addr/${address}/utxo`;
            const response = await axios.get(url, {
                timeout: DEFAULT_TIMEOUT,
            });
            return fixUTXOs(response.data
                .map((utxo) => ({
                txHash: utxo.txid,
                amount: utxo.amount.toString(),
                vOut: utxo.vout,
                confirmations: utxo.confirmations,
            }))
                .filter((utxo) => confirmations === 0 ||
                utxo.confirmations >= confirmations), 8).sort(sortUTXOs);
        };
        this.fetchTXs = async (address, confirmations = 0) => {
            const url = `${this.endpoint().replace(/\/$/, "")}/address/transactions/${address}`;
            const { data } = await axios.get(url, {
                timeout: DEFAULT_TIMEOUT,
            });
            const received = [];
            for (const tx of data.txs) {
                for (let i = 0; i < tx.vout.length; i++) {
                    const vout = tx.vout[i];
                    if (vout.scriptPubKey.addresses.indexOf(address) >= 0) {
                        received.push({
                            txHash: tx.txid,
                            amount: fixValue(parseFloat(vout.value), 8).toFixed(),
                            vOut: i,
                            confirmations: tx.confirmations,
                        });
                    }
                }
            }
            return received
                .filter((utxo) => confirmations === 0 || utxo.confirmations >= confirmations)
                .sort(sortUTXOs);
        };
        this.broadcastTransaction = async (txHex) => {
            const url = `${this.endpoint().replace(/\/$/, "")}/rawtransactions/sendRawTransaction`;
            const response = await axios.post(url, { hexes: [txHex] }, { timeout: DEFAULT_TIMEOUT });
            if (response.data.error) {
                throw new Error(response.data.error);
            }
            return response.data[0];
        };
        this.testnet = testnet;
    }
}
export const BitcoinDotCom = Callable(BitcoinDotComClass);
//# sourceMappingURL=bitcoinDotCom.js.map